import styled from 'styled-components';

import classNames from 'classnames';
import type { Skin } from '@sorare/core/src/__generated__/globalTypes';
import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { SkinIcon } from '@sorare/core/src/components/collections/SkinIcon';
import { useGetCardSetConfig } from '@sorare/core/src/set';

const SkinButton = styled(ButtonBase)`
  opacity: 0.3;
  &.active {
    opacity: 1;
    &:hover {
      opacity: 1;
    }
  }
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.6;
  }
`;

type Props = {
  skin: Skin | undefined;
  onSkinChange: (skin: Skin | undefined) => void;
  setSlug: string;
};

export const SkinFilter = ({ skin, onSkinChange, setSlug }: Props) => {
  const getCardSetConfig = useGetCardSetConfig();
  const set = getCardSetConfig(setSlug);
  if (set.skins.length === 0) {
    return null;
  }

  return (
    <Horizontal gap={0.5}>
      {set.skins.map(s => (
        <SkinButton
          key={s}
          className={classNames({ active: !skin || skin === s })}
          onClick={() => onSkinChange(skin === s ? undefined : s)}
        >
          <SkinIcon skin={s} size={4} />
        </SkinButton>
      ))}
    </Horizontal>
  );
};
